export default __webpack_public_path__ + "media/collab_opportunity3_icon.5b1aea2ddcb5663b88dadfdb049c54c9.svg";